<h2 mat-dialog-title>Select a recipient</h2>
<div mat-dialog-content>
  <select [(ngModel)]="recipientType" (change)="selectChanged($event)">
    <option value="">Select recipient type</option>
    <option value="Fund">Fund</option>
    <option value="Organization">Organization</option>
    <option value="Custom">Other</option>
  </select>
  @if (recipientType.length) {
    <freeform-org-search
      placeholder="Search or specify a recipient"
      [searchType]="recipientType"
      (selectedOrg)="selectOrg($event)"
      (searchChanged)="searchChanged($event)"
    [value]="recipient"></freeform-org-search>
  }
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button [mat-dialog-close]="data" color="primary">Add</button>
</div>
